import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    q: "Why should I hire a nightlife consultant?",
    a: "Because the difference between a profitable venue and a struggling one is rarely marketing — it's operations, menu, staffing and guest journey. A consultant gives you an outside operator's eyes on all four, quickly.",
  },
  {
    q: "How long is an audit?",
    a: "A full nightclub audit is two days on-ground: one full day of observation and interviews, one day of financial and operational deep-dive. You receive a written action plan within seven days.",
  },
  {
    q: "Do you travel across India?",
    a: "Yes — I work with venues in Mumbai, Delhi, Bengaluru, Kolkata, Goa, Hyderabad, Chandigarh and beyond. Travel and stay are billed at cost, agreed upfront.",
  },
  {
    q: "Can you help existing businesses?",
    a: "Absolutely — most of my work is with existing venues that want to fix profitability, retention or operations without a full re-launch.",
  },
  {
    q: "Can you help new launches?",
    a: "Yes. Pre-launch consulting covers positioning, ops setup, hiring, menu strategy and launch planning — from concept to doors-open.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-40 bg-[#050505]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
            Ch. 09 &mdash; FAQ
          </div>
          <h2 className="font-display text-white text-[34px] sm:text-4xl md:text-6xl lg:text-[64px] leading-[0.98] tracking-[-0.02em]">
            Answers,{" "}
            <em className="font-editorial italic text-[#D4AF37] font-light">
              on the record.
            </em>
          </h2>
          <p className="mt-6 text-white/60 text-sm md:text-base max-w-md leading-relaxed">
            Still need something specific? Send a quick note — I read every
            inbound personally.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-7"
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger className="text-left text-white hover:text-[#D4AF37] py-5 md:py-6 text-[15px] md:text-lg font-normal font-display tracking-tight [&[data-state=open]]:text-[#D4AF37]">
                  <span className="flex items-baseline gap-3 md:gap-4">
                    <span className="text-[#D4AF37]/70 text-[10px] md:text-xs tracking-[0.24em] md:tracking-[0.28em]">
                      0{i + 1}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-white/70 pb-6 md:pb-8 text-[14px] md:text-[15px] leading-relaxed pl-6 md:pl-10 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
